import React from 'react';
const CommunityPage = () => {
  return <div className="bg-cream" data-id="element-290">
      {/* Hero Section with Community Image */}
      <section className="relative" data-id="element-291">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/b6p8rtBXtNfuee4DVycwqi/Jemi_Baby_Community.png" alt="Jemi Baby Care Community" className="w-full h-auto object-cover" data-id="element-292" />
      </section>
      {/* Community Description Section */}
      <section className="py-16" data-id="element-293">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-294">
          <div className="bg-white rounded-lg shadow-md p-8 md:p-12" data-id="element-295">
            <h2 className="text-2xl md:text-3xl font-bold text-brown mb-6 text-center" data-id="element-296">
              🌟 Welcome to the Jemi Baby Care Community 🌟
            </h2>
            <p className="text-gray-700 mb-8" data-id="element-297">
              Motherhood is beautiful, but it can also feel overwhelming. From
              feeding struggles to sleepless nights, sometimes you just need a
              safe space where you can find answers, encouragement, and support.
              That's exactly why we created the Jemi Baby Care Community — a
              circle of moms, guided by expert advice, where you never have to
              walk this journey alone.
            </p>
            <h3 className="text-xl font-bold text-brown mb-4" data-id="element-298">
              ✨ Here's why you'll love being part of our community:
            </h3>
            <ul className="list-none space-y-3 mb-8" data-id="element-299">
              <li className="flex items-start" data-id="element-300">
                <span className="text-brown font-bold mr-2" data-id="element-301">•</span>
                <span data-id="element-302">
                  <strong data-id="element-303">Expert Guidance:</strong> Get access to
                  doctor-approved tips, resources, and practical guides for
                  every stage of your baby's growth.
                </span>
              </li>
              <li className="flex items-start" data-id="element-304">
                <span className="text-brown font-bold mr-2" data-id="element-305">•</span>
                <span data-id="element-306">
                  <strong data-id="element-307">Everyday Solutions:</strong> From simple recipes to
                  weaning strategies, you'll always know what to cook, how to
                  feed, and how to care for your little one with confidence.
                </span>
              </li>
              <li className="flex items-start" data-id="element-308">
                <span className="text-brown font-bold mr-2" data-id="element-309">•</span>
                <span data-id="element-310">
                  <strong data-id="element-311">Mom-to-Mom Support:</strong> Share experiences, ask
                  questions, and connect with mothers who truly understand what
                  you're going through.
                </span>
              </li>
              <li className="flex items-start" data-id="element-312">
                <span className="text-brown font-bold mr-2" data-id="element-313">•</span>
                <span data-id="element-314">
                  <strong data-id="element-315">Confidence & Peace of Mind:</strong> Say goodbye to
                  stress and second-guessing — and hello to informed, joyful
                  parenting.
                </span>
              </li>
            </ul>
            <div className="flex justify-center mb-8" data-id="element-316">
              <a href="https://selar.com/50131b4y7a" target="_blank" rel="noopener noreferrer" className="bg-brown text-cream px-6 py-3 rounded-full hover:bg-brown-dark transition-colors duration-300 inline-block" data-id="element-317">
                Join Our Community
              </a>
            </div>
            <p className="text-gray-700 mb-4" data-id="element-318">
              👩‍⚕️ Backed by Dr. Sophia Igbineweka — medical professional, mom,
              and founder of Jemi Baby Care — this community is designed to give
              you the balance of professional advice and everyday mom-to-mom
              encouragement.
            </p>
            <p className="text-gray-700 mb-8" data-id="element-319">
              💡 Join us today and give yourself the gift of support, knowledge,
              and confidence.
            </p>
            <p className="text-gray-700 mb-8 text-center font-medium" data-id="element-320">
              Because raising a child takes more than love — it takes a
              community. 💕
            </p>
            <div className="flex justify-center" data-id="element-321">
              <a href="https://selar.com/50131b4y7a" target="_blank" rel="noopener noreferrer" className="bg-brown text-cream px-6 py-3 rounded-full hover:bg-brown-dark transition-colors duration-300 inline-block" data-id="element-322">
                Join Our Community
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="py-16 bg-beige" data-id="element-323">
        <div className="container mx-auto px-4" data-id="element-324">
          <h2 className="text-2xl md:text-3xl font-bold text-brown mb-8 text-center" data-id="element-325">
            Benefits of Joining Our Community
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-326">
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-327">
              <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mb-4" data-id="element-328">
                <span className="text-brown text-2xl" data-id="element-329">👩‍👩‍👧</span>
              </div>
              <h3 className="text-xl font-bold text-brown mb-2" data-id="element-330">
                Peer Support
              </h3>
              <p className="text-gray-700" data-id="element-331">
                Connect with other mothers who understand exactly what you're
                going through and can offer practical advice and emotional
                support.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-332">
              <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mb-4" data-id="element-333">
                <span className="text-brown text-2xl" data-id="element-334">👩‍⚕️</span>
              </div>
              <h3 className="text-xl font-bold text-brown mb-2" data-id="element-335">
                Expert Access
              </h3>
              <p className="text-gray-700" data-id="element-336">
                Get your questions answered by our team of experts, including
                pediatric nutritionists and experienced mothers.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-337">
              <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mb-4" data-id="element-338">
                <span className="text-brown text-2xl" data-id="element-339">🎯</span>
              </div>
              <h3 className="text-xl font-bold text-brown mb-2" data-id="element-340">
                Live Q&A Sessions
              </h3>
              <p className="text-gray-700" data-id="element-341">
                Participate in regular live sessions where you can ask questions
                and get real-time answers about baby nutrition and care.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default CommunityPage;